<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Liturgie" />
            <LaLiturgie />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LaLiturgie from './LaLiturgie.vue';


export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        LaLiturgie,
        FooterComp,
    }
}
</script>